export default "__VITE_ASSET__DGIUBQTo__"